import React from 'react';
import styled from 'styled-components';

export default styled(props => <div className={props.className}>{props.children}</div>)`
  display: ${props => (props.showSuggestionBox ? 'block' : 'none')};
  border-radius: 0 0 0.25rem 0.25rem;
  border: 1px solid #ced4da;
  border-top-width: 0;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 1;

  .suggestion-container label {
    color: #292b2c;
  }
`;
